export function isMediaSegment(
  item?: ProposalSegment | Partial<ProposalSegment & Record<'id', string>>,
): item is MediaSegment {
  return item?.type === 'media';
}
